module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9172264a24247609bfe4e7cb10380007.png";